import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BtnAction2Component } from '../btn-action2/btn-action2.component';

@Component({
    selector: 'aa-btn-action2-secondary',
    templateUrl: '../btn-action2/btn-action2.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        '../btn-action-secondary/btn-action-secondary.component.scss',
        './btn-action2-secondary.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtnAction2SecondaryComponent extends BtnAction2Component
{
    constructor ()
    {
        super();
    }
}
